module.exports = __webpack_public_path__ + "Panton-Regular.195fe5a41218.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Panton-Regular.woff
// module id = ./src/styles/fonts/Panton-Regular.woff
// module chunks = 21